export const LANGUAGE_EN = 'EN';
export const LANGUAGE_ZH = 'ZH';
